import { h } from "vue"
export default {
    props:{
        usePointerStyle: {type: Boolean, default: false }
    },

    setup(props:any, {slots}:{slots:any}) {
        return () => h("li", {style: props.usePointerStyle ? "cursor:pointer" : null}, slots.default());
    }
}